export const PARENT_WELL_INFO = 'PARENT_WELL_INFO';
export const PARENT_WELL_INFO_SUCCESS = 'PARENT_WELL_INFO_SUCCESS';
export const PARENT_WELL_INFO_ERROR = 'PARENT_WELL_INFO_ERROR';


export const CHILD_WELL_INFO = 'CHILD_WELL_INFO';
export const CHILD_WELL_INFO_SUCCESS = 'CHILD_WELL_INFO_SUCCESS';
export const CHILD_WELL_INFO_ERROR = 'CHILD_WELL_INFO_ERROR';

export const DTS_SOCKET_DATA= 'DTS_SOCKET_DATA';
export const DAS_SOCKET_DATA = 'DAS_SOCKET_DATA';

export const CROSS_WELL_CORDINATES_DATA = 'CROSS_WELL_CORDINATES_DATA';
export const CROSS_WELL_CORDINATES_DATA_SUCCESS = 'CROSS_WELL_CORDINATES_DATA_SUCCESS';
export const CROSS_WELL_CORDINATES_DATA_ERROR = 'CROSS_WELL_CORDINATES_DATA_ERROR';

export const CROSS_WELL_BULK_UPDATE = 'CROSS_WELL_BULK_UPDATE';
export const CROSS_WELL_BULK_UPDATE_SUCCESS = 'CROSS_WELL_BULK_UPDATE_SUCCESS';
export const CROSS_WELL_BULK_UPDATE_ERROR = 'CROSS_WELL_BULK_UPDATE_ERROR';